<template>
  <PhotosArticles />
</template>

<script>
import { defineComponent } from "vue";

// Components
import PhotosArticles from "../components/PhotosArticles.vue";
export default defineComponent({
  name: "HomeView",

  components: {
    PhotosArticles,
  },
});
</script>
